<form (submit)="onSubmit()" class="step-form" #stepForm>
  @if (headlineTextkey) {
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [innerHTML]="headlineTextkey | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
    </div>
  }

  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
      <button class="help-toggle hide-for-medium" [attr.aria-expanded]="showInlineHelp" [attr.aria-controls]="" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
      @if (helpTextkey) {
        <div class="callout lighter-gray step-help" [class.show]="showPageHelp">
          <div [innerHTML]="helpTextkey | translate"></div>
          @if (anfrage?.userInput?.waermepumpe_stromverbrauch_bekannt === 'ja') {
            <div [innerHTML]="helpTextkey + '.waermepumpe' | translate"></div>
          }
          @if (hasInlineHelp) {
            <button type="button" [attr.aria-expanded]="showInlineHelp" [attr.aria-controls]="" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggleInlineHelp()"  class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</button>
          }
        </div>
      }
    </div>
    <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1" #formWrapper>
      @if (formError) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.verbrauchsdaten.error.' + formError | translate"></p>
        </div>
      }
      @if (formWarning) {
        <div role="alert" class="form-warnings">
          <p [innerHTML]="textkeyPrefix + '.verbrauchsdaten.warning.' + formWarning | translate"></p>
        </div>
      }

      <div class="invoice">
        @if (invoiceErrors) {
          <div role="alert" class="form-errors">
            <p [innerHTML]="textkeyPrefix + '.verbrauchsdaten.error.invoice.' + invoiceErrors['error'] | translate"></p>
            @if (backendErrors.length > 0) {
              <ul>
                @for (error of backendErrors; track error) {
                  <li [innerHTML]="error | translate: placeholderErrors"></li>
                }
              </ul>
            }
          </div>
        }

        @for (field of invoice; track field) {
          @if (field.isActive()) {
            <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{field.type}} {{field.classes}}" [class.affected-field]="isAffectedFieldForError(field)"></div>
          }
        }

      </div>

    </div>
  </div>

  <app-step-buttons [previousLink]="previousStep? previousStep.path : null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextDisabled]="!form.valid" [nextClass]="loadingData? 'loading' : ''"></app-step-buttons>
</form>
